<template>
	<div class="wrap wrap_overview">
		<section class="section_overview">
			<div
				class="overview_left"
				:class="
					(props.data.invest_score.score === '' || props.data.invest_score.score == null) &&
					'locked not-draggable cursor-pointer'
				"
				@click="
					!props.data.invest_score.score &&
						popupStore.openPopup({
							content: ONLY_PICKED,
						})
				"
			>
				<div>
					<h4 class="report_title_sub">투자점수</h4>
					<div class="title_score">
						<strong>{{ props.data.invest_score.score }}</strong
						><span>점</span>
					</div>
					<p v-if="props.data.invest_score.price">기준가 {{ priceFormat(props.data.invest_score.price) }}원</p>
				</div>
				<img
					v-if="props.data.invest_score.score === '' || props.data.invest_score.score == null"
					src="@/assets/img/common/lock_overview.svg"
					loading="lazy"
					alt="자물쇠 이미지"
				/>
			</div>
			<div class="overview_right">
				<div class="tooltip_container">
					<button
						class="btn_tooltip"
						@mousemove="
							deviceStore.getDevice === 'MO' ? (isTooltipOpened = !isTooltipOpened) : (isTooltipOpened = true)
						"
						@mouseout="isTooltipOpened = false"
					>
						<img src="@/assets/img/common/question.svg" alt="도움말" loading="lazy" />
					</button>
					<div v-if="isTooltipOpened" class="box_tooltip">
						<p class="tooltip_title">
							{{ COMPANY_ANALYSIS_TOOLTIP }}
						</p>
					</div>
				</div>
				<div class="right_row">
					<div>
						<h4 class="report_title_sub">PER</h4>
						<p>{{ replaceNA(props.data.top_box.PER) }}</p>
					</div>
					<div>
						<h4 class="report_title_sub">PBR</h4>
						<p>{{ replaceNA(props.data.top_box.PBR) }}</p>
					</div>
				</div>
				<div class="right_row">
					<div>
						<h4 class="report_title_sub">ROE</h4>
						<p>{{ props.data.top_box.ROE }}</p>
					</div>
					<div>
						<h4 class="report_title_sub">배당률</h4>
						<p>{{ props.data.top_box.시가배당률 }}</p>
					</div>
				</div>
			</div>
		</section>
		<section v-if="props.data.company_outline" class="section_enterprise_overview">
			<div class="report_title_wrapper">
				<h2 class="report_title">기업 개요</h2>

				<AudioPlayer :src="props.audioFile" />
			</div>
			<div v-dompurify-html="props.data.company_outline" class="c_editorContent c_editorContent_outline"></div>
		</section>
		<section v-if="props.data.report" class="section_one_minute_report">
			<h2 class="report_title">1분 리포트</h2>
			<div v-dompurify-html="props.data.report" class="c_editorContent c_editorContent_outline"></div>
		</section>
		<section class="section_capital_change">
			<h2 class="report_title">자본금 변동사항</h2>
			<div class="capital_change_content">
				<div class="table_wrap">
					<div class="table_item">
						<p class="table_head"><span>증자 현황</span><span>(최근 3년)</span></p>
						<p class="table_data">{{ getCapitalChangeValue(props.data.capital_change.increase_status) }}</p>
					</div>
					<div class="table_item">
						<p class="table_head"><span>감자 현황</span><span>(최근 3년)</span></p>
						<p class="table_data">{{ getCapitalChangeValue(props.data.capital_change.reduction_status) }}</p>
					</div>
					<div class="table_item">
						<p class="table_head"><span>미상환 CB</span><span>(전환사채)</span></p>
						<p class="table_data">{{ getCapitalChangeValue(props.data.capital_change.outstanding_cb) }}</p>
					</div>
					<div class="table_item">
						<p class="table_head"><span>미상환 BW</span><span>(신주인수권부사채)</span></p>
						<p class="table_data">{{ getCapitalChangeValue(props.data.capital_change.outstanding_bw) }}</p>
					</div>
				</div>
			</div>
		</section>
		<section class="section_basic_info">
			<h2 class="report_title">기본 정보</h2>
			<div class="basic_info_content">
				<p v-if="props.date" class="base_date">{{ removeTimeFromDate(props.date) }} 기준</p>
				<!-- table 관련 시멘틱 태그 사용 시 반응형 레이아웃 적용에 어려움이 있어서 div 사용 -->
				<div class="table_wrap">
					<div class="table_item">
						<p class="table_head">시가총액(억원)</p>
						<p class="table_data">{{ props.data.bottom_box.시가총액 ?? '-' }}</p>
					</div>
					<div class="table_item">
						<p class="table_head">배당수익률(연간)</p>
						<p class="table_data">{{ props.data.bottom_box.시가배당률 ?? '-' }}</p>
					</div>
					<div class="table_item">
						<p class="table_head">발행주식수</p>
						<p class="table_data">{{ props.data.bottom_box.발행주식수 ?? '-' }}</p>
					</div>
					<div class="table_item">
						<p class="table_head">유동주식수</p>
						<p class="table_data">{{ props.data.bottom_box.유동주식수 ?? '-' }}</p>
					</div>
					<div class="table_item">
						<p class="table_head">유동비율</p>
						<p class="table_data">{{ props.data.bottom_box.유동비율 ?? '-' }}</p>
					</div>
					<div class="table_item">
						<p class="table_head">PER(분기)</p>
						<p class="table_data_withPercent">
							{{ replaceNA(props.data.bottom_box.PER) ?? '-' }}
						</p>
					</div>
					<div class="table_item">
						<p class="table_head">PBR(분기)</p>
						<p class="table_data">{{ replaceNA(props.data.bottom_box.PBR) ?? '-' }}</p>
					</div>
					<div class="table_item">
						<p class="table_head">ROE(분기)</p>
						<p class="table_data">{{ props.data.bottom_box.ROE ?? '-' }}</p>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script setup lang="ts">
// core
import { ref } from 'vue';

// api
import { GetInvestReportOverviewRes_KR } from '@/api/report';
// component
import AudioPlayer from '@/components/report/AudioPlayer.vue';
// constant
import { COMPANY_ANALYSIS_TOOLTIP } from '@/constants/title';
import { ONLY_PICKED } from '@/constants/title';
// store
import { useDeviceStore } from '@/stores/device';
// store
import { usePopupStore } from '@/stores/popup';
// util
import { priceFormat } from '@/utils/function/format';
import { removeTimeFromDate } from '@/utils/function/format';

// -----variable-----
const props = defineProps<{
	data: GetInvestReportOverviewRes_KR;
	date?: string;
	auth?: boolean;
	audioFile?: string;
}>();
const popupStore = usePopupStore();
const deviceStore = useDeviceStore();
const isTooltipOpened = ref(false);

// -----function-----
const getCapitalChangeValue = (value?: number) => {
	if (typeof value === 'number') {
		switch (value) {
			case 1:
				return '유';
			case 0:
				return '무';
		}
	} else {
		return '-';
	}
};

const replaceNA = (value: string): string => (value === 'N/A' ? '-' : value);
</script>

<style scoped lang="scss">
.wrap_overview {
	.report_title_wrapper {
		display: flex;
		align-items: center;
		justify-content: space-between;
		gap: 0.8rem;
	}

	.report_title {
		font-size: var(--font-s-x-large);
		font-weight: var(--font-w-bold);
		line-height: 2.387rem;
		white-space: nowrap;
	}
	.report_title_sub {
		color: var(--color-base-light, #c6c6d6);
		font-size: var(--font-s-mid);
		font-weight: var(--font-w-light);
		line-height: 1.9rem;
	}
	.section_overview {
		display: flex;
		justify-content: space-between;
		gap: 1rem;
		width: 100%;
		margin: 0 auto;
		.overview_left,
		.overview_right {
			border-radius: 8px;
			background: var(--color-bg-mid, #212c3f);
		}
		.overview_left {
			position: relative;
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			gap: 0.4rem;
			align-self: stretch;
			padding: 2rem;
			.title_score {
				display: flex;
				align-items: center;
				gap: 0.5rem;
				strong {
					color: var(--color-primary, var(--text-white-base, #ff5e00));
					text-align: center;
					font-size: var(--font-s-x-large);
					font-weight: var(--font-w-bold);
					line-height: normal;
				}
				span {
					font-size: var(--font-s-x-large);
					font-weight: var(--font-w-bold);
					line-height: normal;
				}
			}
			p {
				font-size: var(--font-s-mid);
				font-weight: var(--font-w-light);
				line-height: 1.9rem;
			}
		}
		.overview_left > div {
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
		}
		.overview_left.locked > div {
			filter: blur(4px);
		}
		.overview_left.locked > img {
			width: 3rem;
			height: 3.8rem;
			position: absolute;
		}
		.overview_right {
			width: 100%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;
			gap: 1.2rem;
			padding: 1.6rem;
			.tooltip_container {
				width: 100%;
				display: flex;
				justify-content: end;
				position: relative;
				.btn_tooltip {
					display: block;
					width: 2.4rem;
					height: 2.4rem;
					cursor: pointer;
				}
				.box_tooltip {
					position: absolute;
					top: 3rem;
					right: -1rem;
					z-index: 1;
					background-color: var(--color-bg-light);
					padding: 1.6rem;
					border-radius: 0.8rem;
					box-shadow: 4px 4px 10px 0px #0000004d;
					white-space: nowrap;
					.tooltip_title {
						font-size: var(--font-s-mid);
						font-weight: var(--font-w-light);
						line-height: 1.2;
					}
				}
			}
			.right_row {
				display: flex;
				align-items: flex-start;
				width: 100%;
				div {
					display: flex;
					flex-direction: column;
					justify-content: center;
					align-items: center;
					width: 100%;
				}
				p {
					font-size: var(--font-s-mid);
					font-weight: var(--font-w-semi-bold);
					line-height: 1.79rem;
				}
			}
		}
	}
	.section_enterprise_overview {
		display: flex;
		flex-direction: column;
		gap: 2rem;
	}
	.section_enterprise_overview {
		display: flex;
		flex-direction: column;
		gap: 2rem;
	}
	.section_one_minute_report {
		display: flex;
		flex-direction: column;
		gap: 2rem;
	}
	.section_capital_change {
		display: flex;
		flex-direction: column;
		gap: 2rem;
		.capital_change_content {
			.table_wrap {
				display: grid;
				grid-template-columns: repeat(4, 1fr);
				grid-template-rows: repeat(1, 1fr);
				@media screen and (max-width: 1280px) {
					grid-template-columns: repeat(2, 1fr);
					grid-template-rows: repeat(2, 1fr);
				}
				.table_head {
					display: flex;
					flex-direction: column;
					padding: 0.8rem 1rem;
					justify-content: center;
					align-items: start;
					border: 1px solid var(--color-base-mid-dark, #393d45);
					background: var(--color-bg-mid, #212c3f);
					font-size: var(--font-s-mid);
					font-weight: var(--font-w-light);
					line-height: 1.9rem;
					@media screen and (max-width: 480px) {
						flex-direction: column;
					}
				}
				.table_data {
					display: flex;
					height: 3.5rem;
					padding: 0.8rem 1rem;
					justify-content: start;
					align-items: center;
					gap: 1rem;
					align-self: stretch;
					border: 1px solid var(--color-base-mid-dark, #393d45);
					font-size: var(--font-s-mid);
					font-weight: var(--font-w-semi-bold);
					line-height: normal;
				}
			}
		}
	}
	.section_basic_info {
		display: flex;
		flex-direction: column;
		gap: 2rem;
		.basic_info_content {
			display: flex;
			flex-direction: column;
			gap: 1rem;
			.base_date {
				color: var(--color-base-light, #c6c6d6);
				font-size: var(--font-s-small);
				font-weight: var(--font-w-light);
				line-height: normal;
			}
			.table_wrap {
				display: grid;
				grid-template-columns: repeat(3, 1fr);
				grid-template-rows: repeat(3, 1fr);
				@media screen and (max-width: 1280px) {
					grid-template-columns: repeat(2, 1fr);
					grid-template-rows: repeat(4, 1fr);
					.table_item {
						grid-column: auto;
						grid-row: auto;
					}
				}
				.table_item {
					display: flex;
					flex-direction: column;
					.table_head {
						display: flex;
						padding: 0.8rem 1rem;
						justify-content: start;
						align-items: center;
						gap: 1rem;
						align-self: stretch;
						border: 1px solid var(--color-base-mid-dark, #393d45);
						background: var(--color-bg-mid, #212c3f);
						font-size: var(--font-s-mid);
						font-weight: var(--font-w-light);
						line-height: 1.9rem;
					}
					.table_data {
						display: flex;
						height: 3.5rem;
						padding: 0.8rem 1rem;
						justify-content: start;
						align-items: center;
						gap: 1rem;
						align-self: stretch;
						border: 1px solid var(--color-base-mid-dark, #393d45);
						font-size: var(--font-s-mid);
						font-weight: var(--font-w-semi-bold);
						line-height: normal;
					}
					.table_data_withPercent {
						display: flex;
						height: 3.5rem;
						padding: 0.8rem 1rem;
						justify-content: start;
						align-items: center;
						border: 1px solid var(--color-base-mid-dark, #393d45);
						font-size: var(--font-s-mid);
						font-weight: var(--font-w-semi-bold);
						line-height: normal;
					}
				}
				.table_item:nth-child(1) {
					grid-column: 1;
					grid-row: 1;
					grid-column: span 2;
				}
				.table_item:nth-child(2) {
					grid-column: 2;
					grid-row: 1;
					grid-column: span 1;
				}
				.table_item:nth-child(3) {
					grid-column: 1;
					grid-row: 2;
				}
				.table_item:nth-child(4) {
					grid-column: 2;
					grid-row: 2;
				}
				.table_item:nth-child(5) {
					grid-column: 3;
					grid-row: 2;
				}
				.table_item:nth-child(6) {
					grid-column: 1;
					grid-row: 3;
				}
				.table_item:nth-child(7) {
					grid-column: 2;
					grid-row: 3;
				}
				.table_item:nth-child(8) {
					grid-column: 3;
					grid-row: 3;
				}
				@media screen and (max-width: 1280px) {
					.table_item:nth-child(n) {
						grid-column: auto;
						grid-row: auto;
					}
				}
			}
		}
	}
}
.emptyData_alert {
	padding: 3.2rem 0rem;
	font-size: var(--font-s-regular);
	font-weight: var(--font-w-light);
	line-height: 1.2;
	text-align: center;
}
</style>
